export enum DocumentActions {
  Add = "add",
  Update = "update",
  Delete = "delete",
  Patch = "patch",
}

export enum UploadType {
  Attachment = "Attachment",
  NewsPhoto = "NewsPhoto",
  Document = "Document",
  Video = "Video",
}

export interface AttachmentModel {
    id: string;
    downloadUrl: string;
    title?: string;
}